import { render } from "./ChatContent.vue?vue&type=template&id=e2c09fd2&scoped=true&ts=true"
import script from "./ChatContent.vue?vue&type=script&lang=ts"
export * from "./ChatContent.vue?vue&type=script&lang=ts"

import "./ChatContent.vue?vue&type=style&index=0&id=e2c09fd2&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c09fd2"]])

export default __exports__